module.exports = __webpack_public_path__ + "img/login-img1.56133b02.png";